import React, { useRef, useEffect } from "react";
import SimpleBar from "simplebar-react";
import MarkdownPreview from "../MarkdownPreview";
import style from "./style.module.css";

const simpleBarStyles = {
  height: "100%"
};

type SectionContentProps = {
  content: string;
  sectionTitle?: string;
};

function SectionContent({ content, sectionTitle }: SectionContentProps) {
  const scrollContainer = useRef(null as any);

  useEffect(() => {
    scrollContainer.current &&
      scrollContainer.current.parentElement.scrollTo(0, 0);
  }, [content]);

  return (
    <div className={style.container}>
      <SimpleBar
        scrollableNodeProps={{
          ref: scrollContainer
        }}
        style={simpleBarStyles}
      >
        <h2 className={style.title}>{sectionTitle}</h2>
        <MarkdownPreview source={content} />
      </SimpleBar>
    </div>
  );
}

export default SectionContent;
